
























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { CURRENCY_FORMAT } from '@/helpers/currency';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import notificationService from '@/services/notificationService';
import machineryRentalsRepository from '@/modules/machinery/services/machineryRentalsRepository';
import projectsRepository from '@/services/projectsRepository';
import Popup from '@/components/default/Popup.vue';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';

import customersRepository from '@/services/customers/customersRepository';

import {
    MachineryRentalInvoicingMode,
    MachineryRentalFrequency,
} from '@/modules/machinery/enums';

@Component({
  components: {
    Popup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
  },
})
export default class MachineryRentalPopup extends Vue {
    @Prop({required: true})
    private machineryId!: string;

    private show: boolean = false;
    private saving: boolean = false;
    private loading: boolean = false;

    private rentalModel: IMachineryRentalUpdateCommand = {
        id: '',
        machineryId: '',
        customerId: '',
        projectId: '',
        begin: '',
        end: null,
        lastInvoicedDate: null,
        invoicingMode: 0,
        frequency: 0,
        unitPrice: 0,
        taxrate: 21,
        rentalMode: 0,
        prepayment: false,
        contactId: '',
    };

    public add() {
        Object.assign(this.rentalModel, {
            customerId: '',
            projectId: '',
            contactId: '',
            begin: '',
            end: null,
            lastInvoicedDate: null,
            invoicingMode: 0,
            frequency: 0,
            unitPrice: 0,
            taxrate: 21,
            rentalMode: 0,
            prepayment: false,
        });
        this.show = true;
    }

    public edit(model: IMachineryRentalDto) {
        const updateObject: IMachineryRentalUpdateCommand = {
            id: model.id,
            machineryId: model.machineryId,
            customerId: model.customerId,
            projectId: model.projectId,
            begin: model.begin,
            end: model.end,
            lastInvoicedDate: model.lastInvoicedDate,
            invoicingMode: model.invoicingMode,
            frequency: model.frequency,
            unitPrice: model.unitPrice,
            taxrate: model.taxrate,
            rentalMode: model.rentalMode,
            prepayment: model.prepayment,
            contactId: model.contactId,
        };

        Object.assign(this.rentalModel, updateObject);
        this.show = true;
    }

    private mounted() {
        this.rentalModel.machineryId = this.machineryId;
    }

    private async save() {
        try {
            const validationResult = (this.$refs.MachineryRentalForm as any).instance.validate();
            if (validationResult.isValid) {
                this.saving = true;

                if (this.machineryId && this.machineryId !== '') {
                    this.rentalModel.machineryId = this.machineryId;
                }

                if (this.rentalModel.id !== '') {
                    // Update
                    await machineryRentalsRepository.update(this.rentalModel);
                } else {
                    // Create
                    await machineryRentalsRepository.create(this.rentalModel);
                }

                notificationService.saved();
                this.show = false;
                this.$emit('saved');
            } else {
                notificationService.invalidForm();
            }
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.saving = false;
        }
    }

    get customersOptions() {
        const self = this;
        return {
            dataSource: new DataSource({
                store: new dxCustomStore({
                load: async (loadOptions) => {
                    const result = await customersRepository.get(loadOptions);
                    return {
                        data: result.data,
                    };
                },
                byKey: (val: any) => {
                    return val;
                },
                }),
                paginate: true,
            }),
            valueExpr: 'id',
            displayExpr: 'displayName',
            searchEnabled: true,
        };
    }

    get projectsOptions() {
        const self = this;
        return {
            dataSource: new DataSource({
                store: new dxCustomStore({
                    key: 'id',
                    load: async (loadOptions) => {
                        if (Array.isArray(loadOptions.filter) &&
                            loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {

                            return {
                                data: [],
                                totalCount: 0,
                            };
                        }

                        if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
                            loadOptions.filter =
                                [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
                        }

                        const result = await projectsRepository.lookup(loadOptions);

                        return {
                            data: result.data.data,
                            totalCount: result.data.totalCount,
                        };
                    },
                    byKey: async (val: any) => {
                        return projectsRepository.getSingle(val).then((result: any) => {
                            return result.data;
                        });
                    },
                }),
                paginate: true,
            }),
            valueExpr: 'id',
            displayExpr: 'name',
            searchExpr: 'name',
            searchEnabled: true,
            showClearButton: true,
        };
    }


    get rentalFields() {
        return [
            {
                itemType: 'simple',
                dataField: 'customerId',
                editorOptions: this.customersOptions,
                editorType: 'dxSelectBox',
                label: {
                    text: 'Klant',
                },
                validationRules: [
                    {type: 'required', message: 'Veld is verplicht'},
                ],
            },
            {
                itemType: 'simple',
                dataField: 'projectId',
                editorOptions: this.projectsOptions,
                editorType: 'dxSelectBox',
                label: {
                    text: 'project',
                },
            },
            {
                itemType: 'simple',
                dataField: 'begin',
                editorOptions: { width: '100%', useMaskBehavior: true },
                editorType: 'dxDateBox',
                label: {
                    text: 'Begin',
                },
                validationRules: [
                    {type: 'required', message: 'Veld is verplicht'},
                ],
            },
            {
                itemType: 'simple',
                dataField: 'end',
                editorOptions: { width: '100%', useMaskBehavior: true },
                editorType: 'dxDateBox',
                label: {
                    text: 'Einde',
                },
            },
            {
                itemType: 'simple',
                dataField: 'lastInvoicedDate',
                editorOptions: { width: '100%', useMaskBehavior: true },
                editorType: 'dxDateBox',
                label: {
                    text: 'Gefactureerd tot',
                },
            },
            {
                itemType: 'simple',
                dataField: 'invoicingMode',
                editorOptions: {
                    items: [
                        { value: MachineryRentalInvoicingMode.Manual, text: 'Manueel' },
                        { value: MachineryRentalInvoicingMode.Periodic, text: 'Periodiek' },
                    ],
                    valueExpr: 'value',
                    displayExpr: 'text',
                    searchEnabled: true,
                },
                editorType: 'dxSelectBox',
                label: {
                    text: 'Facturatiemodus',
                },
                validationRules: [
                    {type: 'required', message: 'Veld is verplicht'},
                ],
            },
            {
                itemType: 'simple',
                dataField: 'frequency',
                editorOptions: {
                    items: [
                        { value: MachineryRentalFrequency.Daily, text: 'Dagelijks' },
                        { value: MachineryRentalFrequency.Weekly, text: 'Wekelijks' },
                        { value: MachineryRentalFrequency.Monthly, text: 'Maandelijks' },
                    ],
                    valueExpr: 'value',
                    displayExpr: 'text',
                    searchEnabled: true,
                },
                editorType: 'dxSelectBox',
                label: {
                    text: 'Frequentie',
                },
                validationRules: [
                    {type: 'required', message: 'Veld is verplicht'},
                ],
            },
            {
                itemType: 'simple',
                dataField: 'rentalMode',
                editorOptions: {
                    items: [
                        { value: 0, text: 'Huren' },
                        { value: 1, text: 'Huurkoop' },
                    ],
                    valueExpr: 'value',
                    displayExpr: 'text',
                    searchEnabled: true,
                },
                editorType: 'dxSelectBox',
                label: {
                    text: 'Soort',
                },
                validationRules: [
                 {type: 'required', message: 'Veld is verplicht'},
                ],
            },
            {
                itemType: 'simple',
                dataField: 'unitPrice',
                editorType: 'dxNumberBox',
                editorOptions: {
                    format: CURRENCY_FORMAT,
                },
                label: {
                    text: 'Prijs',
                },
                validationRules: [
                    {type: 'required', message: 'Veld is verplicht'},
                ],
            },
            {
                itemType: 'simple',
                dataField: 'taxrate',
                editorType: 'dxNumberBox',
                label: {
                    text: 'BTW %',
                },
                validationRules: [
                    {type: 'required', message: 'Veld is verplicht'},
                ],
            },
            {
                itemType: 'simple',
                dataField: 'prepayment',
                editorType: 'dxCheckBox',
                label: {
                    text: 'Voorafbetaling',
                },
            },
        ];
    }
}
